import { useTheme } from "styled-components";
import TextWithIcon from "common/Text/TextWithIcon";
import { ICON_TYPES } from "@shared/common/constants";

const SymbolAndExchangeSummary = ({ symbol, exchange }) => {
  const appTheme = useTheme();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        paddingTop: "12px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "12px",
          color: appTheme.colors.textColor,
        }}
      >
        <TextWithIcon
          text={symbol}
          iconType={ICON_TYPES.COIN}
          coinOrExchangeName={symbol}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: appTheme.colors.textColor,
        }}
      >
        <TextWithIcon
          text={exchange}
          iconType={ICON_TYPES.EXCHANGE}
          coinOrExchangeName={exchange}
        />
      </div>
    </div>
  );
};

export default SymbolAndExchangeSummary;
